import type { AirExchangeProductDetails } from "@b2bportal/air-exchange-api";
import {
  type ModifyProduct,
  ModifyProductEnum,
  Product,
} from "@b2bportal/purchase-api";
import { getObjectKeysAsObject, setContextWithKey } from "@checkout/helpers";
import { cartHelpers, ParentState } from "@checkout/index";
import { ContactSelectors } from "@checkout/states/common";
import { assign } from "xstate";

import { getSelectedTripParent } from "../../selectors";
import type { FlightExchangeContext } from "../../types";
import { getOriginalFlightItinerary } from "./selectors";

export const actions = {
  addExchangeFlightProductMod: assign(
    (context: FlightExchangeContext, _event: unknown) => {
      const contactInformation = ContactSelectors.getContactInformation({
        context,
      });
      const selectedTrip = getSelectedTripParent({ context });
      const originalItinerary = getOriginalFlightItinerary({ context });
      const { tripId, returnFareId, outgoingFareId } = selectedTrip;
      const fareId = returnFareId ?? outgoingFareId;
      const exchangeProductDetails: AirExchangeProductDetails = {
        tripId,
        fareId,
      };
      const productMod: ModifyProduct = {
        ModifyProduct: ModifyProductEnum.ExchangeProduct,
        product: Product.Flight,
        productId: originalItinerary?.bookedItinerary.id,
        request: {
          type: Product.Flight,
          value: exchangeProductDetails,
        },
      };

      const ctxWithFlight = cartHelpers.addQuoteProductModification(
        productMod,
        context
      );

      return setContextWithKey(
        ctxWithFlight,
        `${ParentState.cartQuote}.customerEmail`,
        contactInformation?.email
      );
    }
  ),
};

export const ActionTypes = getObjectKeysAsObject(actions);
